var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "500" } },
    [
      _c("w-card-title", [
        _vm._v(_vm._s(_vm.$ct("custom-buttons.edit-title"))),
      ]),
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { sm: "12" } },
                [
                  _c("w-input", {
                    attrs: {
                      label: _vm.$ct("custom-buttons.labels.name"),
                      fancy: "",
                    },
                    model: {
                      value: _vm.value.Name,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "Name", $$v)
                      },
                      expression: "value.Name",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { sm: "12" } },
                [
                  _c("w-input", {
                    attrs: {
                      label: _vm.$ct("custom-buttons.labels.title"),
                      fancy: "",
                    },
                    model: {
                      value: _vm.value.Title,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "Title", $$v)
                      },
                      expression: "value.Title",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { sm: "12" } },
                [
                  _c("w-input", {
                    attrs: {
                      label: _vm.$ct("custom-buttons.labels.url"),
                      fancy: "",
                    },
                    model: {
                      value: _vm.value.Url,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "Url", $$v)
                      },
                      expression: "value.Url",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { sm: "12" } },
                [
                  _c("app-icon-picker", {
                    attrs: { label: _vm.$ct("custom-buttons.labels.icon") },
                    model: {
                      value: _vm.value.Icon,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "Icon", $$v)
                      },
                      expression: "value.Icon",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { sm: "12" } },
                [
                  _c("w-select", {
                    attrs: {
                      items: _vm.positionItems,
                      label: _vm.$ct("custom-buttons.labels.position"),
                      fancy: "",
                    },
                    model: {
                      value: _vm.value.Position,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "Position", $$v)
                      },
                      expression: "value.Position",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { sm: "12" } },
                [
                  _c("w-checkbox", {
                    attrs: {
                      label: _vm.$ct(
                        "custom-buttons.labels.open-on-double-click"
                      ),
                    },
                    model: {
                      value: _vm.value.OpenOnDoubleClick,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "OpenOnDoubleClick", $$v)
                      },
                      expression: "value.OpenOnDoubleClick",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { sm: "12" } },
                [
                  _c("w-checkbox", {
                    attrs: {
                      label: _vm.$ct("custom-buttons.labels.require-single"),
                    },
                    on: { input: _vm.onRequireSingleChanged },
                    model: {
                      value: _vm.value.RequireSingle,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "RequireSingle", $$v)
                      },
                      expression: "value.RequireSingle",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { sm: "12" } },
                [
                  _c("w-checkbox", {
                    attrs: {
                      label: _vm.$ct("custom-buttons.labels.require-selection"),
                    },
                    on: { input: _vm.onRequireSelectionChanged },
                    model: {
                      value: _vm.value.RequireSelection,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "RequireSelection", $$v)
                      },
                      expression: "value.RequireSelection",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { sm: "12" } },
                [
                  _c("w-checkbox", {
                    attrs: {
                      label: _vm.$ct("custom-buttons.labels.admin-only"),
                    },
                    model: {
                      value: _vm.value.AdminOnly,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "AdminOnly", $$v)
                      },
                      expression: "value.AdminOnly",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { sm: "12" } },
                [
                  _c("w-checkbox", {
                    attrs: {
                      label: _vm.$ct("custom-buttons.labels.padded-modal"),
                    },
                    model: {
                      value: _vm.value.PaddedModal,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "PaddedModal", $$v)
                      },
                      expression: "value.PaddedModal",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { sm: "12" } },
                [
                  _c("w-checkbox", {
                    attrs: {
                      label: _vm.$ct(
                        "custom-buttons.labels.integrate-in-browse"
                      ),
                    },
                    model: {
                      value: _vm.value.IntegrateInBrowse,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "IntegrateInBrowse", $$v)
                      },
                      expression: "value.IntegrateInBrowse",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm.value.IntegrateInBrowse
            ? [
                _c(
                  "w-row",
                  [
                    _c(
                      "w-col",
                      { attrs: { sm: "6" } },
                      [
                        _c("w-select", {
                          attrs: {
                            items: _vm.iframePositionItems,
                            label: _vm.$ct(
                              "custom-buttons.labels.iframe-position"
                            ),
                            fancy: "",
                          },
                          model: {
                            value: _vm.value.IframePosition,
                            callback: function ($$v) {
                              _vm.$set(_vm.value, "IframePosition", $$v)
                            },
                            expression: "value.IframePosition",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "w-col",
                      { attrs: { sm: "6" } },
                      [
                        _c("w-select", {
                          attrs: {
                            items: _vm.iframeWidthModeItems,
                            label: _vm.$ct(
                              "custom-buttons.labels.iframe-width-mode"
                            ),
                            fancy: "",
                          },
                          model: {
                            value: _vm.value.IframeWidthMode,
                            callback: function ($$v) {
                              _vm.$set(_vm.value, "IframeWidthMode", $$v)
                            },
                            expression: "value.IframeWidthMode",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm.value.IframeWidthMode === 0 ||
                _vm.value.IframeWidthMode === 2
                  ? _c(
                      "w-row",
                      [
                        _c(
                          "w-col",
                          { attrs: { sm: "12" } },
                          [
                            _c("w-input", {
                              attrs: {
                                type: "number",
                                label: _vm.$ct(
                                  "custom-buttons.labels.iframe-" +
                                    (_vm.value.IframeWidthMode === 2
                                      ? "start"
                                      : "fixed") +
                                    "-width"
                                ),
                                fancy: "",
                              },
                              model: {
                                value: _vm.value.IframeFixedWidth,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.value,
                                    "IframeFixedWidth",
                                    _vm._n($$v)
                                  )
                                },
                                expression: "value.IframeFixedWidth",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.value.IframeWidthMode === 1
                  ? _c(
                      "w-row",
                      [
                        _c(
                          "w-col",
                          { attrs: { sm: "12" } },
                          [
                            _c("w-input", {
                              attrs: {
                                type: "number",
                                label: _vm.$ct(
                                  "custom-buttons.labels.iframe-percent-width"
                                ),
                                fancy: "",
                              },
                              model: {
                                value: _vm.value.IframePercentWidth,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.value,
                                    "IframePercentWidth",
                                    _vm._n($$v)
                                  )
                                },
                                expression: "value.IframePercentWidth",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            : _vm._e(),
        ],
        2
      ),
      _c(
        "w-card-actions",
        [
          _c("w-button", { staticClass: "cancel", on: { click: _vm.close } }, [
            _vm._v(_vm._s(_vm.$t("common.cancel"))),
          ]),
          _c("w-spacer"),
          _c("w-button", { on: { click: _vm.save } }, [
            _vm._v(_vm._s(_vm.$t("common.save"))),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }